import React from 'react';
import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Navbar from './Components/Navbar/Navbar';
import About from './Components/Navbar/About/About';
import Home from './Components/Navbar/Home/Home';
import Projects from './Components/Navbar/Projects/Projects';
import Branch from './Components/Navbar/Branches/Branch';

function App() {
  return (
    <Router>                
      <Switch>
        <Route exact path = '/'>
          <Home/>
        </Route>
        <Route path ='/about'>
          <About/>
        </Route>
        <Route path = '/projects'>
          <Projects/>
        </Route>
        <Route path = '/branches'>
          <Branch/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
